import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  setReportsHistory as onSetReportsHistory,
  clearReportsHistory as onClearReportsHistory,
  setHistoryReportReady as onSetHistoryReportReady,
  setHistoryReportNotReady as onSetHistoryReportNotReady
} from './../../actions/reportsHistoryActions'

const mapStateToProps = (state) => ({
  reportsHistoryData: get(state, ['reportsHistory', 'data'], []),
  isHistoryReportReady: get(state, ['reportsHistory', 'isReady'], false),
})

const mapDispatchToProps = {
  onSetReportsHistory,
  onClearReportsHistory,
  onSetHistoryReportReady,
  onSetHistoryReportNotReady
}

const withReportsHistory = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReportsHistory }